import type { ReactNode } from "react";
import { SheetLogo } from "./SheetLogo.tsx";
import "./outside-shell.css";
import { useScrollFade } from "@baton/ui";

/**
 * A screen the authenticated document renders outside the workspace shell: the not-found route
 * at `*`, a workspace route that failed to load, and the root redirect's error. The document's
 * ground is the chrome surface, so such a screen sits on the work sheet inset on it, the frame
 * the shell and the boot screen draw, and its text keeps the light surface it was written for.
 * With no rail to carry the product's mark, the sheet's head carries its logo (2026-09-28).
 */
export function OutsideShell({ children }: { readonly children: ReactNode }) {
  // The sheet fades at an edge its page continues past, as the shell's main region does (`useScrollFade`, 2026-10-21).
  const sheet = useScrollFade<HTMLDivElement>();
  return (
    <div className="b-outside-shell">
      <div ref={sheet} className="b-outside-shell__sheet">
        <SheetLogo />
        {children}
      </div>
    </div>
  );
}
